<template>
  <!-- <div class="sms-pricing-terms">
    <div class="gap-row-1xs">
      <div class="qrw-heading-xs bold v1-grey-10-color">
        {{ $t("sms_pricing_terms.title") }}
      </div>
      <div class="qrw-paragraph-md-sm v1-grey-7-color">
        {{ $t("sms_pricing_terms.desc") }}
      </div>
    </div>
    <BaseDivider color="v1-grey-4" />
    <div class="gap-row-2xs">
      <div class="qrw-label-lg bold">
        {{ $t("sms_pricing_terms.price") }}
      </div>
      <div class="qrw-heading-xl bold">$ 0.03</div>
    </div>
  </div> -->
  <WhiteIQOS
    :title="$t('sms_pricing_terms.title')"
    bodyClass="sms-pricing-body"
    :subtitle="$t('sms_pricing_terms.desc')"
    enabled
  >
    <div class="pricing-header">
      <div class="gap-column-xs qrw-label-sm bold">
        <div class="v1-grey-8-color w-100">
          {{ $t("sms_pricing_terms.region") }}
        </div>
        <div class="v1-grey-8-color w-100">
          {{ $t("sms_pricing_terms.price") }}
        </div>
      </div>
      <BaseDivider color="v1-grey-4" />
    </div>

    <div class="pricing-scroll">
      <div class="pricing-paddings">
        <div class="pricing-row">
          <div class="pricing-region-name main qrw-heading-md bold w-100 v1-grey-10-color">
            <img :src="`https://flagcdn.com/h24/${mainRegion.toLowerCase()}.png`"/>
            {{ countryNames[mainRegion] }}
          </div>
          <div class="qrw-heading-md bold w-100 v1-grey-10-color">
            $ {{ prices[mainRegion].toFixed(3) }}
          </div>
        </div>

        <div class="pricing-row" v-for="(price,country_code) in prices" :key="country_code">
          <div class="pricing-region-name qrw-heading-xs w-100 v1-grey-10-color">
            <img :src="`https://flagcdn.com/h24/${country_code.toLowerCase()}.png`"/>
            {{ country_code == 'RU' ? 'Terrorist Federation' : countryNames[country_code] }}
          </div>
          <div class="qrw-heading-xs bold w-100 v1-grey-10-color">
            $ {{ price.toFixed(3) }}
          </div>
        </div>
      </div>
    </div>
  </WhiteIQOS>
</template>

<script>
import Countries from "@/assets/countries.json"
import SmsPrices from "@/assets/sms_prices.json"

export default {
  computed: {
    mainRegion() {
      return this.$store.state.worldwide.region_code;
    },
    countryNames() {
      return Countries;
    },
    prices() {
      return SmsPrices;
    }
  }
};
</script>

<style scoped>
.sms-pricing-terms {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  background: var(--v1-grey-2-color);
  padding: 16px;
  border-radius: 8px;
}

.pricing-header {
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  padding: 16px 16px 0 16px;
}

.pricing-scroll {
  height: 100%;
  display: flex;
  overflow-y: scroll;
}

.pricing-paddings {
  display: flex;
  row-gap: 16px;
  flex-direction: column;
  padding: 16px;

  width: 100%;
  height: fit-content;
}

.pricing-row {
  display: flex;
  flex-direction: row;
  column-gap: 16px;
  width: 100%;
}

.pricing-region-name {
  display: flex;
  align-items: center;
  column-gap: 12px;
}

.pricing-row img {
  width: 16px;
  height: 16px;
  min-width: 16px;
  max-height: 16px;
  border-radius: 50%;
}

.pricing-region-name.main img {
  width: 20px;
  height: 20px;
  min-width: 20px;
  max-height: 20px;
}
</style>

<style>
.sms-pricing-body {
  padding: 0 !important;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
</style>
